import { isNil } from 'lodash';
import { API } from '@shared/types/api';

export function getChannelCardDefinition(
  cardDefinitions: API.CardDefinitionFragment[] | undefined,
  cardDefinitionId: string | null | undefined,
): API.CardDefinitionFragment | undefined {
  if (isNil(cardDefinitionId)) {
    return cardDefinitions?.find(def => def.root);
  } else {
    return cardDefinitions?.find(def => def.id === cardDefinitionId);
  }
}
